
import Seo from '../../components/Seo';
export default function BPOPage() {
  
  const chk = (
    <svg aria-hidden="true" className="chk" viewBox="0 0 16 16"><path fill="none" stroke="#007A6E" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" d="M2 8.5 6 12.5 14 3.5" /></svg>
  );
  const dots = (
    <span className="dots"><span style={{background: '#ff5f57'}}></span><span style={{background: '#febc2e'}}></span><span style={{background: '#28c840'}}></span></span>
  );
  return (
    <>
      <Seo title="BPO & Shared Services Productivity Intelligence Software | TeamGrid™" description="Hold one performance standard across every delivery site and shift. Benchmark locations fairly, fix timezone handoffs, and show clients the proof." />
<header className="sect" style={{paddingBottom: '24px'}}>
  <div className="container">
    <div className="frow" style={{padding: '0'}}>
      <div>
        <span className="hero-badge"><img className="mark" src="/assets/mark-teamgrid.svg" alt="" />Solutions › BPO &amp; Shared Services <span className="arr">›</span></span>
        <h1 style={{fontSize: '52px', lineHeight: '57px', letterSpacing: '-2.1px', fontWeight: '700', color: 'var(--ink-hero)', marginBottom: '22px'}}>One standard,<br /><span style={{color: '#a9aab3'}}>every site, every shift</span></h1>
        <p className="fd" style={{fontSize: '17px', lineHeight: '26px', color: 'var(--ink-soft)', marginBottom: '26px', maxWidth: '520px'}}>Manila runs hot, Kraków runs cold, and nobody can prove why. Work handed over at the end of a shift waits twelve hours for a reply. TeamGrid gives distributed operations one consistent measure of performance across every location.</p>
        <ul className="hero-checks">
          <li>{chk}<span><b>Cross-location benchmarking.</b> Compare regions on the same scale, fairly.</span></li>
          <li>{chk}<span><b>Handoff visibility.</b> See where timezone handovers stall or drop.</span></li>
          <li>{chk}<span><b>Proof for stakeholders.</b> Productivity you can show a client, on demand.</span></li>
        </ul>
        <div className="hero-cta-row" style={{marginBottom: '0'}}>
          <a className="btn-primary" href="/register">Start free</a>
          <a className="btn-ghost" href="/book-demo">Get a demo for BPO teams →</a>
        </div>
      </div>
      <div className="frame">
        <div className="frame-h">{dots}DELIVERY SITES — THIS WEEK</div>
        <div className="applist" style={{padding: '16px 18px'}}>
          <span className="ap"><i style={{background: '#2DBDB8'}}></i>Manila<span className="bar"><b style={{width: '86%', background: '#2DBDB8'}}></b></span><span className="pc">86</span></span>
          <span className="ap"><i style={{background: '#469FD8'}}></i>Kraków<span className="bar"><b style={{width: '81%', background: '#469FD8'}}></b></span><span className="pc">81</span></span>
          <span className="ap"><i style={{background: '#8B75D7'}}></i>Bengaluru<span className="bar"><b style={{width: '84%', background: '#8B75D7'}}></b></span><span className="pc">84</span></span>
          <span className="ap"><i style={{background: '#F2673A'}}></i>Bogotá<span className="bar"><b style={{width: '68%', background: '#F2673A'}}></b></span><span className="pc">68</span></span>
        </div>
        <div className="sumcard" style={{borderTop: '1px solid var(--line-soft)'}}>
          <div className="sc-t">VARIATION WATCH</div>
          <p>Bogotá sits <b>16 points</b> below the group. The gap is not effort — it is a <b>9h wait</b> on approvals that Manila clears in 40 minutes. Same playbook, different queue design.</p>
        </div>
      </div>
    </div>
  </div>
</header>

<section className="sect" style={{paddingTop: '32px'}}>
  <div className="container">
    <h2 className="sect-h2">Consistent quality<br /><span className="dim">at global scale</span></h2>
    <p className="sect-sub">Performance visibility that travels across regions, clients and shifts. No screenshots, no keystrokes, patterns not people.</p>

    <div className="frow">
      <div className="fr-copy">
        <span className="fl" style={{color: '#2DBDB8'}}>CROSS-LOCATION BENCHMARKING</span>
        <h3>Compare regions without punishing them</h3>
        <p className="fd">TeamGrid benchmarks productivity across locations on one scale, so disparities show up as process gaps rather than as blame. When one site is doing something better, the pattern is visible and portable.</p>
        <ul className="fpts">
          <li><span className="sarr">→</span>One measure applied consistently across every site</li>
          <li><span className="sarr">→</span>Best practice found by pattern, not by anecdote</li>
          <li><span className="sarr">→</span>Quality variation tracked week over week</li>
        </ul>
      </div>
      <div className="frame">
        <div className="frame-h">{dots}QUALITY VARIATION — QUARTER</div>
        <div className="applist" style={{padding: '16px 18px'}}>
          <span className="ap">Q1 spread<span className="bar"><b style={{width: '82%', background: '#E0483D'}}></b></span><span className="pc">28 pts</span></span>
          <span className="ap">Q2 spread<span className="bar"><b style={{width: '61%', background: '#F2A73A'}}></b></span><span className="pc">21 pts</span></span>
          <span className="ap">Q3 spread<span className="bar"><b style={{width: '44%', background: '#2DBDB8'}}></b></span><span className="pc">15 pts</span></span>
          <span className="ap">Target<span className="bar"><b style={{width: '30%', background: '#34A851'}}></b></span><span className="pc">10 pts</span></span>
        </div>
      </div>
    </div>

    <div className="frow rev">
      <div className="frame">
        <div className="frame-h">{dots}FOLLOW-THE-SUN HANDOFF</div>
        <div className="anlist">
          <div className="ancard"><span className="aico" style={{background: '#e6f7f5'}}>→</span><span><span className="at" style={{color: '#007A6E'}}>MANILA → KRAKÓW</span><span className="am">Clean handover. <b>18 min</b> to first touch on the receiving side.</span></span></div>
          <div className="ancard"><span className="aico" style={{background: '#fff8e8'}}>⚠</span><span><span className="at" style={{color: '#b45318'}}>KRAKÓW → BOGOTÁ</span><span className="am"><b>4.5h</b> gap. 12 cases sat unowned through the overlap window.</span></span></div>
          <div className="ancard"><span className="aico" style={{background: '#eef4fd'}}>◷</span><span><span className="at" style={{color: '#366EB6'}}>SUGGESTED OVERLAP</span><span className="am">Shift Bogotá start by <b>90 min</b> to close the dead zone.</span></span></div>
        </div>
      </div>
      <div className="fr-copy">
        <span className="fl" style={{color: '#469FD8'}}>TIMEZONE HANDOFFS</span>
        <h3>Work that survives the night shift</h3>
        <p className="fd">Most cross-region delay is not slow work, it is dead air between shifts. TeamGrid reveals communication delays and handoff inefficiencies, then shows the overlap window that would fix them.</p>
        <ul className="fpts">
          <li><span className="sarr">→</span>Time-to-first-touch on every handover</li>
          <li><span className="sarr">→</span>Unowned work flagged during the gap, not after</li>
          <li><span className="sarr">→</span>Overlap windows recommended from real activity</li>
        </ul>
      </div>
    </div>

    <div className="frow">
      <div className="fr-copy">
        <span className="fl" style={{color: '#8B75D7'}}>ATTRITION IMPACT</span>
        <h3>Turnover stops resetting the floor</h3>
        <p className="fd">In shared services, people move. TeamGrid tracks how long a seat takes to reach full output after a change, so ramp plans are built on the real curve and coverage is arranged before quality slips.</p>
        <ul className="fpts">
          <li><span className="sarr">→</span>Ramp curve measured per role and per process</li>
          <li><span className="sarr">→</span>Coverage risk flagged before a queue feels it</li>
          <li><span className="sarr">→</span>Client-facing reporting stays steady through churn</li>
        </ul>
      </div>
      <div className="frame sumcard">
        <div className="sc-t">STAKEHOLDER REPORT — SEPTEMBER</div>
        <p style={{fontSize: '13.5px', lineHeight: '20px'}}>Quality variation across four sites narrowed to <b>15 points</b>. Cross-timezone case completion is <b>28% faster</b> after the overlap change. Two seats turned over in August and returned to full output in <b>11 days</b>, against a 17-day baseline.</p>
      </div>
    </div>
  </div>
</section>

<section className="sect" style={{paddingTop: '8px'}}>
  <div className="container">
    <div className="roi-cards" style={{marginTop: '0'}}>
      <div className="roi-card"><div className="rl">QUALITY SPREAD</div><div className="rv">−32%</div><p>Less variation in quality between delivery locations.</p></div>
      <div className="roi-card"><div className="rl">HANDOFFS</div><div className="rv">28%</div><p>Faster cross-timezone completion once dead air is closed.</p></div>
      <div className="roi-card"><div className="rl">STAKEHOLDERS</div><div className="rv">+40%</div><p>Higher satisfaction when performance can be shown, not argued.</p></div>
      <div className="roi-card"><div className="rl">TURNOVER</div><div className="rv">35%</div><p>Faster recovery to full output after a seat changes hands.</p></div>
    </div>
    <p className="roi-note">*Typical results reported by TeamGrid BPO and shared-services workspaces.</p>
  </div>
</section>

<div className="container"><div className="workswith"><span className="wl">WORKS BEST WITH</span><a href="/monitoring">Workforce Analytics →</a><a href="/resource-optimizer">Managed Services →</a></div></div>

<section className="sect" style={{padding: '8px 0 24px'}}>
  <div className="container">
    <h2 className="sect-h2" style={{fontSize: '28px', lineHeight: '36px'}}>Common questions</h2>
    <div className="faq">
      <details><summary>Is TeamGrid suitable for global BPO teams?</summary><p>Yes. It gives cross-location productivity insight so BPO and shared-services groups can manage performance consistently, whatever the site or the shift pattern.</p></details>
      <details><summary>Does it help with cross-location comparisons?</summary><p>Yes. TeamGrid benchmarks productivity across regions to show where disparities sit and which site is running the better practice.</p></details>
      <details><summary>Can it improve handoff performance across teams?</summary><p>Yes. It exposes communication delays and handoff inefficiencies between shifts and regions, including work that sits unowned during an overlap gap.</p></details>
    </div>
  </div>
</section>

<section className="final" style={{paddingTop: '48px'}}>
  <div className="container-wide">
    <div className="final-band" style={{paddingBottom: '88px'}}>
      <h2>Same quality bar<br />in every location</h2>
      <a className="btn-white" href="/register">Get started FREE</a>
    </div>
  </div>
</section>
    </>
  );
}
